import React, { useEffect } from 'react';
// import { useDispatch } from 'react-redux';
import { BrowserRouter as Router,Route,Routes} from 'react-router';
import { ToastContainer, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { routes } from './routes-names';
import Main from '../main';
import { getUser } from '../../redux/user';
import ProtectedRoute from './protected';
import Room from '../room';
import ScrollToTop from './scroll-to-top';
import { useAppDispatch } from '../../redux/hooks';

const AppRoutes = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        (async function () {
            await dispatch(getUser());
        })();
    }, [dispatch]);

    return (
        <Router >
            <ScrollToTop />
            <Routes>
                <Route  path={routes.main} element={<Main />} />
                <Route path="/*" element={<ProtectedRoute><Room /></ProtectedRoute>} />
            </Routes>
            <ToastContainer autoClose={5000} transition={Zoom} theme="colored" hideProgressBar />
        </Router>
    );
};

export default AppRoutes;
